/**
 * This file is a part of Amblique's projects.
 *
 * Copyright © Amblique - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

export default {
  baseStyle: (props) => ({
    row: {
      display: 'flex',
      alignItems: 'center',
      padding: 4,
      backgroundColor: 'white',
      borderRadius: 'md',
      borderWidth: '2px',
      borderStyle: 'solid',
      borderColor: props.selected ? 'black' : 'gray.200',
      transition: 'all 0.2s',
      width: '100%',
      cursor: props.disabled ? 'not-allowed' : 'pointer',
      _hover: props.disabled ? {} : {
        borderColor: props.selected ? 'black' : 'gray.300',
      },
      _focus: {
        outline: 'none',
        boxShadow: 'outline',
      },
      opacity: props.disabled ? 0.6 : 1,
    },
    thumbnail: {
      width: '80px',
      height: '80px',
      minWidth: '80px',
      minHeight: '80px',
      marginRight: 4,
      borderRadius: 'sm',
      overflow: 'hidden',
      flexShrink: 0,
    },
    thumbnailImage: {
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
      width: '100%',
      height: '100%',
      border: '1px solid',
      borderColor: 'gray.300',
    },
    thumbnailFallback: {
      width: '100%',
      height: '100%',
      backgroundColor: 'gray.100',
      border: '1px solid',
      borderColor: 'gray.300',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    thumbnailFallbackText: {
      fontSize: 'xs',
      color: 'gray.500',
    },
    label: {
      flex: 1,
      marginRight: 4,
    },
    labelText: {
      fontSize: 'md',
      fontWeight: 'normal',
      color: 'gray.900',
    },
    price: {
      marginRight: 4,
      textAlign: 'right',
      minWidth: '120px',
      flexShrink: 0,
    },
    radio: {
      width: '24px',
      height: '24px',
      minWidth: '24px',
      minHeight: '24px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
    },
    radioControl: {
      size: 'md',
      sx: {
        '& .chakra-radio__control': {
          borderColor: 'gray.300',
          backgroundColor: 'transparent',
          _checked: {
            backgroundColor: 'black',
            borderColor: 'black',
            _hover: {
              backgroundColor: 'black',
              borderColor: 'black',
            },
          },
        },
      },
    },
    link: {
      textDecoration: 'none',
      display: 'block',
    },
  }),
  parts: [
    'row',
    'thumbnail',
    'thumbnailImage',
    'thumbnailFallback',
    'thumbnailFallbackText',
    'label',
    'labelText',
    'price',
    'radio',
    'radioControl',
    'link'
  ],
};
